import {Component, Inject} from '@angular/core';
import {MAT_SNACK_BAR_DATA, MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'app-custom-toastr',
  templateUrl: './custom-toastr.component.html',
  styleUrls: ['./custom-toastr.component.scss']
})
export class CustomToastrComponent {

  snackBarClass: string = 'custom-snack-bar';
  iconClass: string = '';

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any,
              private _snackBar: MatSnackBar) {
    if (data.type === 'success') {
      this.snackBarClass = 'custom-snack-bar success';
      this.iconClass = 'fas fa-check-circle'; // Clase de Font Awesome para el icono de éxito
    } else if (data.type === 'error') {
      this.snackBarClass = 'custom-snack-bar error';
      this.iconClass = 'fas fa-exclamation-circle'; // Clase de Font Awesome para el icono de error
    } else if (data.type === 'info') {
      this.snackBarClass = 'custom-snack-bar info';
      this.iconClass = 'fas fa-info-circle'; // Clase de Font Awesome para el icono de información
    }
  }

  dismissSnackBar() {
    this._snackBar.dismiss();
  }
}
